module.exports = __webpack_public_path__ + "pc/img/swiper_bg_03.a3757562.jpg";